<template>
  <ul class="nav flex-column">
    <span class="navbar-brand">
      <img alt="ブランド" class="cursor-pointer" src="@/assets/images/tamaishiki_logo.png" @click="goToRootPath" />
    </span>

    <p>ようこそ！{{ currentUser.name }}さん <br />ID種別: {{ currentIDTypeTitle }}</p>

    <span v-if="importingInProgress">
      <SideBarProgress v-for="progress in importingProgresses" :key="progress.id" v-bind="progress" />
    </span>
    <span v-else>
      <SideBarItem v-for="(name, index) in currentSidebarItems" :key="index" v-bind="getSidebarItemByName(name)" />

      <li class="nav-item">
        <span class="nav-link cursor-pointer" @click="logOut()">
          <span data-feather="bar-chart-2"></span>
          <img src="@/assets/images/Icon open-account-logout.png" width="18.62" height="17.64" />
          ログアウト
        </span>
      </li>
    </span>

    <div class="fixed-bottom">
      ©︎ 2020 Tamai Investment Educations Inc.
    </div>
  </ul>
</template>

<script>
import SideBarItem from '@/components/sidebars/SideBarItem.vue';
import SideBarProgress from '@/components/sidebars/SideBarProgress.vue';
import { currentUser } from '@/helpers/Authentication.js';
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  components: {
    SideBarItem,
    SideBarProgress,
  },
  computed: {
    currentSidebarItems() {
      return this.role.currentRole.sidebarItems;
    },
    currentIDTypeTitle() {
      return this.role.currentRole.idTypeTitle;
    },
    importingProgresses() {
      return this.getSidebarProgressesUpToId(this.currentImportProgressId);
    },
    ...mapState(['role']),
    ...mapState({
      currentImportProgressId: (state) => state.sidebar_progress.currentImportProgressId,
    }),
    ...currentUser,
    ...mapGetters('sidebar_item', ['getSidebarItemByName']),
    ...mapGetters('sidebar_progress', ['getSidebarProgressesUpToId']),
    ...mapGetters('sidebar_progress', ['importingInProgress']),
  },
  methods: {
    logOut() {
      this.logout();

      // Redirect to login page
      if (this.$route.fullPath.indexOf('login') < 0 && this.$route.fullPath.indexOf('tamaishiki_private') < 0) {
        this.$router.push({ name: 'login' });
      }
    },
    goToRootPath() {
      this.exitImportingStudents();

      this.$router.push({ name: 'home' });
    },
    ...mapActions('auth', ['logout']),
    ...mapActions('student_importer', ['exitImportingStudents']),
  },
};
</script>
